var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    {
      staticClass: "col-sm-6 col-md-4 col-lg-3 col-xl-2",
      on: {
        click: function ($event) {
          return _vm.$emit("click", _vm.$vnode.key)
        },
      },
    },
    [
      _c("div", { staticClass: "card moulding-sale-card" }, [
        _c("div", { staticClass: "card-header aspect-5-4" }, [
          _c("div", { staticClass: "info text-muted" }, [
            _vm._v(_vm._s(_vm.moulding.length.colour.name)),
            _c("br"),
            _vm._v(_vm._s(_vm.moulding.length.profile.name)),
            _c("br"),
            _vm._v(
              _vm._s(_vm.round(_vm.moulding.length.width_mm, 0)) + "mm Wide"
            ),
            _c("br"),
            _vm._v(
              _vm._s(_vm.round(_vm.moulding.length.depth_mm, 0)) + "mm Deep"
            ),
          ]),
          _c(
            "div",
            { staticClass: "aspect-box" },
            [
              _c("b-img-lazy", {
                staticClass: "card-img-top",
                attrs: {
                  src: `/images/picture-frame-chevrons/${_vm.itemCode}/500.jpg`,
                  alt: _vm.altTag,
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.itemCode) + " (" + _vm._s(_vm.numMetres) + "m)"),
          ]),
          _c("small", [
            _vm._v(
              "Grade " +
                _vm._s(_vm.moulding.grade.name) +
                " - " +
                _vm._s(_vm.moulding.discount) +
                "% off"
            ),
          ]),
          _c("p", { staticClass: "tag green" }, [
            _vm._v("£" + _vm._s(_vm.price)),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }